export class RoleType {
  static ADMIN = "admin";
  static MANAGER = "manager";
  static NORMAL = "normal";

  static RoleTypeList = [
    {
      label: "Admin",
      value: RoleType.ADMIN,
    },
    {
      label: "Manager",
      value: RoleType.MANAGER,
    },
    {
      label: "Normal",
      value: RoleType.NORMAL,
    },
  ];
}
